





























import Vue, { VueConstructor } from "vue";
import VaButton from "@/components/atoms/VaButton.vue";
import wizardStepsMixin, {
  WizardMixin,
} from "@/components/mixins/wizardStepsMixin";
import cloneDeep from "lodash/clone";
import { WizardConfiguration } from "@/models/wizardConfiguration";
import validationMixin from "@/components/mixins/validationMixin";
import tenantService from "@/services/tenantService";
import PresentationSetupSelector from "@/components/molecules/presentationOptions/PresentationSetupSelector.vue";

export default (Vue as VueConstructor<WizardMixin>).extend({
  name: "StepDisplay",
  mixins: [wizardStepsMixin, validationMixin],
  data() {
    return {
      presentationSetup: 1,
    };
  },
  components: {
    VaButton,
    PresentationSetupSelector,
  },
  computed: {
    isMainTenant(): boolean {
      return tenantService.isMainTenant();
    },
  },
  methods: {
    selectSetup(n: number) {
      this.presentationSetup = n;
    },
    onFinish() {
      const res = this.wizardConfiguration
        ? cloneDeep(this.wizardConfiguration)
        : ({} as WizardConfiguration);
      res.presentationSetupMode = this.presentationSetup;
      this.$emit("onUpdateConfig", res);
      this.onNext();
    },
  },
});
